import React from "react";

/**
 * Veterans for Indiana — official logo (dark navy text + green stars + green Indiana outline).
 * Served from /assets/logo.webp for performance and offline-safe builds.
 */
export default function Logo({ className = "", alt = "Veterans for Indiana" }) {
  return (
    <img
      src="/assets/logo.webp"
      alt={alt}
      className={className}
      width="220"
      height="80"
      decoding="async"
    />
  );
}
